import * as React from 'react';
import { ListWrapper } from './ExpandableList.styles';
export var ExpandableList = function (_a) {
    var testId = _a.testId, children = _a.children;
    return React.createElement(ListWrapper, { "data-testid": testId }, children);
};
//# sourceMappingURL=ExpandableList.js.map